if ( typeof CharacterCounter !== 'function' ) {

	/*
	 * Live character count for a custom property text field.
	 *
	 * The field belongs to the product form and is rendered by the section, so this
	 * element sits beside it rather than wrapping it: moving the input inside a
	 * wrapper would not change what gets posted, but it would put a custom element
	 * between the form and a field the form validates, which is not worth the risk
	 * for a label. The field is found by id instead.
	 *
	 * The denominator is rendered in Liquid rather than written here, so a page that
	 * loads with JS disabled still shows the limit — only the running count is dead.
	 */
	class CharacterCounter extends HTMLElement {

		constructor(){

			super();

			this.field = document.getElementById(this.dataset.field);
			this.valueElm = this.querySelector('[data-js-counter-value]');

			// a counter pointing at nothing is not an error worth surfacing: the field
			// still works and still enforces its own maxlength
			if ( ! this.field || ! this.valueElm ) return;

			this._onInput = this._onInput.bind(this);
			this.field.addEventListener('input', this._onInput);

			// the field can arrive already filled — a back navigation restoring the page
			// from cache, or an autofill — neither of which fires `input`
			this._onInput();

		}

		disconnectedCallback(){

			// the listener is on the field, not on this element, so it outlives the
			// counter unless it is taken off by hand. The quick-view drawer throws its
			// markup away and rebuilds it on every open.
			if ( this.field ) this.field.removeEventListener('input', this._onInput);

		}

		_onInput(){

			this.valueElm.textContent = this.field.value.length;

		}

	}

	customElements.define('character-counter', CharacterCounter);

}
